import React from 'react'
import PropTypes from 'prop-types'

export default class Token extends React.Component {
  static get propTypes () {
    return {
      preposition: PropTypes.string,
      text: PropTypes.string,
      label: PropTypes.string,
      isPlaceholder: PropTypes.bool,
      mainClick: PropTypes.func,
      secondaryClick: PropTypes.func
    }
  }

  handleSecondClick (e) {
    var { secondaryClick } = this.props
    e.stopPropagation()
    secondaryClick()
  }

  render () {
    var { preposition, label, text, isPlaceholder, mainClick } = this.props
    return (
      <span className="fdn-search-natural-text uk-inline-block uk-margin-small-bottom">
        &nbsp;
        <span>{ preposition }</span>
        &nbsp;
        <span onClick={mainClick}>
          { label ? <span>{label}&nbsp;</span> : null }

          <span className="uk-button-group">
            <span className="uk-button fdn-search-natural-button">
              { text }
            </span>
            { 
              isPlaceholder 
                ? <span data-uk-icon="chevron-down" 
                  className={`uk-flex uk-flex-none uk-flex-middle uk-button clear-param uk-icon 
                  fdn-search-natural-button-alt`}
                            onClick={mainClick}></span>
                : <span data-uk-icon="close"
                  className={`uk-flex uk-flex-none uk-flex-middle uk-button clear-param uk-icon
                  fdn-search-natural-button-alt`}
                            onClick={this.handleSecondClick.bind(this)}></span>
            }
          </span>
        </span>
      </span>
    )
  }
}
